function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import IllegalArgumentException from '../../../../../java/lang/IllegalArgumentException';
import AbstractNode from './AbstractNode';
import Comparable from '../../../../../java/lang/Comparable';
var BoundablePair = /*#__PURE__*/function () {
  function BoundablePair() {
    _classCallCheck(this, BoundablePair);
    BoundablePair.constructor_.apply(this, arguments);
  }
  return _createClass(BoundablePair, [{
    key: "expandToQueue",
    value: function expandToQueue(priQ, minDistance) {
      var isComp1 = BoundablePair.isComposite(this._boundable1);
      var isComp2 = BoundablePair.isComposite(this._boundable2);
      if (isComp1 && isComp2) {
        if (BoundablePair.area(this._boundable1) > BoundablePair.area(this._boundable2)) {
          this.expand(this._boundable1, this._boundable2, priQ, minDistance);
          return null;
        } else {
          this.expand(this._boundable2, this._boundable1, priQ, minDistance);
          return null;
        }
      } else if (isComp1) {
        this.expand(this._boundable1, this._boundable2, priQ, minDistance);
        return null;
      } else if (isComp2) {
        this.expand(this._boundable2, this._boundable1, priQ, minDistance);
        return null;
      }
      throw new IllegalArgumentException('neither boundable is composite');
    }
  }, {
    key: "isLeaves",
    value: function isLeaves() {
      return !(BoundablePair.isComposite(this._boundable1) || BoundablePair.isComposite(this._boundable2));
    }
  }, {
    key: "compareTo",
    value: function compareTo(o) {
      var nd = o;
      if (this._distance < nd._distance) return -1;
      if (this._distance > nd._distance) return 1;
      return 0;
    }
  }, {
    key: "expand",
    value: function expand(bndComposite, bndOther, priQ, minDistance) {
      var children = bndComposite.getChildBoundables();
      for (var i = children.iterator(); i.hasNext();) {
        var child = i.next();
        var bp = new BoundablePair(child, bndOther, this._itemDistance);
        if (bp.getDistance() < minDistance) {
          priQ.add(bp);
        }
      }
    }
  }, {
    key: "getBoundable",
    value: function getBoundable(i) {
      if (i === 0) return this._boundable1;
      return this._boundable2;
    }
  }, {
    key: "getDistance",
    value: function getDistance() {
      return this._distance;
    }
  }, {
    key: "distance",
    value: function distance() {
      if (this.isLeaves()) {
        return this._itemDistance.distance(this._boundable1, this._boundable2);
      }
      return this._boundable1.getBounds().distance(this._boundable2.getBounds());
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return BoundablePair;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Comparable];
    }
  }], [{
    key: "area",
    value: function area(b) {
      return b.getBounds().getArea();
    }
  }, {
    key: "isComposite",
    value: function isComposite(item) {
      return item instanceof AbstractNode;
    }
  }]);
}();
export { BoundablePair as default };
BoundablePair.constructor_ = function () {
  this._boundable1 = null;
  this._boundable2 = null;
  this._distance = null;
  this._itemDistance = null;
  var boundable1 = arguments[0];
  var boundable2 = arguments[1];
  var itemDistance = arguments[2];
  this._boundable1 = boundable1;
  this._boundable2 = boundable2;
  this._itemDistance = itemDistance;
  this._distance = this.distance();
};